export const VERSION = '11.0.0-rc.1.26425.128';
//# sourceMappingURL=pkg-version.js.map